export const isBakerModule =
  window.location.hostname.startsWith('bakers.') ||
  window.location.pathname.split('/').includes('bakers')
